import { useTranslation } from 'react-i18next'
import { Button, Dropdown, Grid } from 'antd'
import { GlobalOutlined, DownOutlined } from '@ant-design/icons'

export const LanguageSelector = () => {
  const { md } = Grid.useBreakpoint()
  const { i18n } = useTranslation()
  const handleLanguageChange = (language: 'en' | 'es' | 'vi' | 'pl') => {
    void i18n.changeLanguage(language)
  }
  const items = [
    { key: 'en', label: 'English', onClick: () => handleLanguageChange('en') },
    { key: 'es', label: 'Español', onClick: () => handleLanguageChange('es') },
    { key: 'vi', label: 'Tiếng Việt', onClick: () => handleLanguageChange('vi') },
    { key: 'pl', label: 'Polski', onClick: () => handleLanguageChange('pl') },
  ]

  return (
    <Dropdown
      menu={{ items }}
      placement='bottomRight'
      trigger={[md ? 'hover' : 'click']}
      getPopupContainer={(trigger) => trigger.parentElement ?? document.body}
    >
      <Button
        type='text'
        icon={<GlobalOutlined />}
        style={{ color: '#0F687C', fontWeight: 600 }}
        data-testid='language-selector-button'
      >
        {i18n.language.toUpperCase()} <DownOutlined style={{ fontSize: '12px', marginLeft: '4px' }} />
      </Button>
    </Dropdown>
  )
}
